<template>
  <v-main>
    <v-layout
      v-if="$apollo.loading"
      style="height:100vh;"
      justify-center
      align-center
      wrap
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      />
    </v-layout>
    <template v-if="!$apollo.loading">
      <core-warnings />
      <core-toolbar />
      <core-drawer />
      <div
        id="core-view"
        :style="getUser && !getUser.onboarding ? 'padding-bottom: 60px' : ''" 
      >
        <router-view :key="$route.path" />
      </div>
      <core-platform-progress v-if="getUser && !getUser.onboarding && !getIsSharingWhitelabels && !getIsInvite" />
      <helper-suspended />
    </template>
  </v-main>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import USER_SETTINGS_QUERY from "@/graphql/queries/UserSettings.gql";


export default {
  computed: {
    ...mapGetters("user", ["getUser", "getIsSharingWhitelabels", "getIsInvite"]),
  },
  methods: {
    ...mapMutations("user", ["setUserSettings"]),
  },
  apollo: {
    userSettings: {
      query: USER_SETTINGS_QUERY,
      pollInterval: 60 * 1000,
      result({ loading, data}) {
        if (!loading) {
          this.setUserSettings(data.userSettings)
        }
      }
    }
  }
}
</script>

<style>
.core-view  {
  padding-bottom: 60px;
}
</style>
